export function fitTextToContainer(el: HTMLElement | null, maxFontSize = 25, minFontSize = 12) {
    if (!el || !el.parentElement) return;

    let fontSize = maxFontSize;
    const parentWidth = el.parentElement.offsetWidth;

    el.style.fontSize = `${fontSize}px`;
    while (el.scrollWidth > parentWidth && fontSize > minFontSize) {
        fontSize -= 1;
        el.style.fontSize = `${fontSize}px`;
    }
}
